var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgKey = function SvgKey(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 15,
    "data-width-24": 22,
    viewBox: "0 0 14.8 14.7",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M9.252.6A4.923 4.923 0 0 0 4.36 5.486c.001.569.101 1.133.295 1.668L.6 11.216l.135 2.787 2.788.136.092-2.037 1.773.19 2.197-2.197A4.896 4.896 0 1 0 9.253.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.252 7.025a1.538 1.538 0 1 0 0-3.077 1.538 1.538 0 0 0 0 3.077"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgKey);
export default ForwardRef;